import { render, staticRenderFns } from "./MobileShare.vue?vue&type=template&id=3b31ef43&scoped=true&"
import script from "./MobileShare.vue?vue&type=script&lang=js&"
export * from "./MobileShare.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b31ef43",
  null
  
)

export default component.exports